import cseaLogo from "../assets/images/homeImage.png";

export default function Logo() {
  return (
    <div className="home-logo">
      <img
        loading="lazy"
        style={{ width: "429px", height: "333px" }}
        className="logo"
        src={cseaLogo}
        alt="Home page theme logo"
      />
    </div>
  );
}
